import React from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import {parse} from 'query-string';
import HeaderView from './HeaderView';
import ClientAddPanel from './clientAddPanel';
import GenerateAccessCodePanel from './generateAccessCodePanel';
import {useClientsStore} from '../ClientsStore';

function HeaderContainer() {
  const shouldOpenAddPanel = parse(useLocation().search).add !== undefined;
  const {dispatch} = useClientsStore();
  const history = useHistory();
  const location = useLocation();
  const [isAccessCodePanelOpen, setIsAccessCodePanelOpen] = React.useState(false);
  const [isAddClientPanelOpen, setIsAddClientPanelOpen] = React.useState(shouldOpenAddPanel);

  return (
    <>
      <HeaderView
        onOpenAccessCodePanel={() => setIsAccessCodePanelOpen(true)}
        onOpenAddClientPanel={() => setIsAddClientPanelOpen(true)}
      />
      <ClientAddPanel
        isOpen={isAddClientPanelOpen}
        onClose={() => {
          history.replace(location.pathname);
          setIsAddClientPanelOpen(false);
          dispatch({type: 'FETCH_DATA'});
        }}
      />
      <GenerateAccessCodePanel
        isOpen={isAccessCodePanelOpen}
        onClose={() => {
          setIsAccessCodePanelOpen(false);
          dispatch({type: 'FETCH_DATA'});
        }}
      />
    </>
  );
}

export default HeaderContainer;
